var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Dialog } from "@gravity-ui/uikit";
import { useGetScheduleByIdQuery } from "@/store/api";
import { TimeRange } from "@/views/places/placeSlots/components/TimeRange";
var calcDurationMinutes = function (hours, minutes) {
    return hours * 60 + minutes;
};
export var WorktimeModal = function (props) {
    var scheduleGetState = useGetScheduleByIdQuery({
        id: props.scheduleId,
    });
    var formMethods = useForm({
        defaultValues: { slot: undefined },
    });
    var handleSubmit = formMethods.handleSubmit;
    var dialogTitleId = "app-data-dialog-title";
    var _a = useState(), rangeValue = _a[0], setRangeValue = _a[1];
    var updateHandler = function (data) {
        setRangeValue(data);
    };
    var submitHandler = function () {
        handleSubmit(function () { return props.onConfirm(rangeValue); })();
    };
    return (scheduleGetState.isSuccess &&
        props.timeSlot && (_jsx(FormProvider, __assign({}, formMethods, { children: _jsxs(Dialog, { size: "s", onClose: props.onClose, open: props.open, "aria-labelledby": dialogTitleId, children: [_jsx(Dialog.Header, { caption: "\u0412\u044B\u0431\u043E\u0440 \u0432\u0440\u0435\u043C\u0435\u043D\u0438", id: dialogTitleId }), _jsx(Dialog.Body, { children: _jsx(TimeRange, { minRangeSize: calcDurationMinutes(scheduleGetState.data.minDurationHours, scheduleGetState.data.minDurationMinutes), maxRangeSize: calcDurationMinutes(scheduleGetState.data.maxDurationHours, scheduleGetState.data.maxDurationMinutes), step: 15, startMinuteOffset: scheduleGetState.data.timeStart, startTimeScale: props.timeSlot.timeStart, endTimeScale: props.timeSlot.timeEnd, onUpdate: updateHandler, name: "slot" }) }), _jsx(Dialog.Footer, { onClickButtonCancel: props.onClose, textButtonCancel: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", onClickButtonApply: submitHandler, textButtonApply: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C" })] }) }))));
};
